module.exports = __webpack_public_path__ + "assets/icons/ic_cancel-ce2c.svg";